export const DetailRow = ({ label, value, hideIfEmpty }) => {
  if (hideIfEmpty && (value === null || value === undefined || value === "")) {
    return null;
  }

  return (
    <div className="mb-3">
      <div className="fz-13" style={{ fontWeight: 600, color: "#6c757d", marginBottom: "3px" }}>
        {label}
      </div>
      <div className="text-dark fz-13" style={{ fontWeight: 500, wordBreak: "break-word" }}>
        {value || "N/A"}
      </div>
    </div>
  );
};
